import _ from 'lodash';
import router from '../../../router';
import questions from '../../../pages/responsive-pages/authenticated/survey/accuracy-survey/consts/accuracy-questions';

const state = {
  questionName: null,
  answers: {},
};

const getters = {
  questionOrder: () => [
    { name: questions.QUESTION_NAMES.NPS },
    { name: questions.QUESTION_NAMES.EDITABILITY },
    { name: questions.QUESTION_NAMES.ALIGNMENT },
    { name: questions.QUESTION_NAMES.UP_TO_DATE },
    { name: questions.QUESTION_NAMES.PREDICTIONS },
  ],
  currentQuestion: state => _.find(questions.QUESTIONS, { name: state.questionName }),
  questionIndex: (state, getters) => _.findIndex(getters.questionOrder, { name: state.questionName }),
  isLastPage: (state, getters) => getters.questionIndex === getters.questionOrder.length - 1,
};

const actions = {
  gotoPage({ getters, commit }, questionName) {
    commit('setQuestionName', questionName);
    return router.push({ path: `/accuracy/${questionName}` });
  },
  nextPage({ getters, commit }) {
    if (getters.isLastPage) {
      return router.push({ path: '/accuracy/done' });
    }
    const { name: nextQuestionName } = getters.questionOrder[getters.questionIndex + 1];
    commit('setQuestionName', nextQuestionName);
    return router.push({ path: `/accuracy/${nextQuestionName}` });
  },
};

const mutations = {
  setQuestionName(state, questionName) {
    state.questionName = questionName;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
